import THDJabraToken from '../contracts/THDJabraToken';

const options = {
  contracts: [ THDJabraToken ],
  web3: {
    fallback: {
      type: "ws",
      //url: "ws://127.0.0.1:7545",
      url: "wss://sepolia.infura.io/ws/v3/e1007988bffa45aba5693b299cfe1886"
    },
  },
};

export default options;
